const Domain = "https://preprod.origin.veyasoft.com";
export default Domain;
